import { BasicIcon } from "@pickit/pickit-components";
import { useTranslation } from "react-i18next";
import { BackButtonTypes } from "./types";

export const BackButton: React.FC<BackButtonTypes> = ({
  back,
}): JSX.Element => {
  const [t] = useTranslation();
  return (
    <div
      onClick={() => {
        back();
      }}
      className="modal-transaction-finish-back"
    >
      <BasicIcon name="arrow-left" color="#145a99" />
      <p>{t("global:back")}</p>
    </div>
  );
};
